import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BASE}${u}` : u);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || fallback;
}
